import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const iterableSystemWebhookAppNameSchema = z.enum(['galatea', 'candyjar', 'ironblood', 'audiobooks']);

export const iterableSystemWebhookPayloadSchema = z
  .object({
    email: z.string().nullish(),
    userId: z.string().nullish(),
    eventName: z.string(),
    dataFields: z
      .object({
        unsubSource: z.string().optional(),
        channelId: z.number().int().nullish(),
        channelIds: z.array(z.number().int()).nullish(),
      })
      .passthrough(),
  })
  .passthrough();

export type IterableSystemWebhookAppName = z.infer<typeof iterableSystemWebhookAppNameSchema>;
export type IterableSystemWebhookPayload = z.infer<typeof iterableSystemWebhookPayloadSchema>;

export const iterableSystemWebhookRouter = c.router(
  {
    emailUnsubscribe: {
      summary: "Cascade Iterable's user-initiated email unsubscribe across the brand's marketing channels",
      method: 'POST',
      path: '/:appName/email-unsubscribe',
      pathParams: z.object({ appName: iterableSystemWebhookAppNameSchema }),
      body: iterableSystemWebhookPayloadSchema,
      responses: {
        200: z.object({ status: z.enum(['processed', 'ignored']) }),
        503: z.object({ status: z.literal('retry') }),
      },
    },
  },
  { pathPrefix: '/api/iterable/v1/system-webhooks', strictStatusCodes: true },
);
